import { Column } from '@/fsd/entities/table/model/types/Column';

export const INITIAL_REMAINS_COLUMNS_VALUES: Column[] = [
  {
    id: 'product_id',
    label: '№',
    isVisible: true,
    type: 'id',
    width: '50',
  },
  {
    id: 'photo_url',
    label: 'Фото',
    isVisible: true,
    type: 'photo',
    width: '70',
  },
  {
    id: 'name',
    label: 'Наименование',
    isVisible: true,
    type: 'name',
    width: '600',
  },
  {
    id: 'total_stock',
    label: 'Остаток',
    isVisible: true,
    type: 'count',
    width: '200',
  },
  {
    id: 'wb_fbo_total',
    label: 'WB FBO',
    isVisible: true,
    type: 'count',
    width: '200',
  },
  {
    id: 'ozon_fbo_total',
    label: 'Ozon FBO',
    isVisible: true,
    type: 'count',
    width: '200',
  },
  {
    id: 'wb_fbs_total',
    label: 'WB FBS',
    isVisible: true,
    type: 'count',
    width: '200',
  },
  {
    id: 'ozon_fbs_total',
    label: 'Ozon FBS',
    isVisible: true,
    type: 'count',
    width: '200',
  },
  {
    id: 'total_cost',
    label: 'Себестоимость',
    isVisible: true,
    type: 'pay',
    width: '200',
  },
];
